<template>
<div class="chapter">
<div class="inner_page">
<section class="level1 hidden" data-number="2" epub:type="epigraph" id="epigraph">
<h1 class="hidden" data-number="2" epub:type="epigraph">Epigraph</h1>
<blockquote class="hanging_indent">
<p>Into this Universe, and <span class="normal">why</span> not knowing,</p>
<p>Nor <span class="normal">whence</span>, like Water willy-nilly flowing;</p>
<p>And out of it, as Wind along the Waste,</p>
<p>I know not <span class="normal">whither</span>, willy-nilly blowing.</p>
</blockquote>
<p class="right_align">From <em>The Rubaiyyat of Omar Kayaam</em></p>
<p class="right_align">Translated by Edward Fitzgerald</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?5a475e54